export default __webpack_public_path__ + "static/media/icon-3-active.f0bbda25.svg";